<template>
  <b-modal :id="modalTagId" ref="add-tags" size="lg" hide-footer centered>
    <template v-slot:modal-title>
      Add {{ modalTitle }}
    </template>

    <div class="paragraph-object-add-tags-alert">
      <b-alert
        :variant="alert.type"
        dismissible
        fade
        :show="alert.show"
        @dismissed="alert.show=0"
        @dismiss-count-down="alertCountDownChanged"
      >
        {{ alert.content }}
      </b-alert>
    </div>

    <div class="paragraph-object-add-tags">
      <p class="mod__current-language">
        Current language is
        <select id="tag-lang" v-model="language">
          <option value="IT">Italian</option>
          <option value="EN">English</option>
        </select>
      </p>

      <!-- Level 1 -->
      <select class="form-control mb-2" id="tag-level1" @change="updateTags($event)" v-model="selectedTagsSchema[0]">
        <option v-for="tag in tagsSchema.level1" :key="tag[tagsObjectKey]" :value="tag[tagsObjectKey]">
          <template v-if="language === 'IT'">
            {{ tag.label }}
          </template>
          <template v-else>
            {{ tag.label_en }}
          </template>
        </option>
      </select>

      <!-- Level 2 -->
      <template v-if="tagsSchema.level2.length > 0 && selectedTagsSchema[0]">             
        <select class="form-control mb-2" id="tag-level2" @change="updateTags($event)" v-model="selectedTagsSchema[1]">
          <option v-for="tag in tagsSchema.level2" :key="tag[tagsObjectKey]" :value="tag[tagsObjectKey]">
            <template v-if="language === 'IT'">
              {{ tag.label }}
            </template>
            <template v-else>
              {{ tag.label_en }}
            </template>
          </option>
        </select>
      </template>

      <!-- Level 3 -->
      <template v-if="tagsSchema.level3.length > 0 && selectedTagsSchema[1]">             
        <select class="form-control mb-2" id="tag-level3" @change="updateTags($event)" v-model="selectedTagsSchema[2]">
          <option v-for="tag in tagsSchema.level3" :key="tag[tagsObjectKey]" :value="tag[tagsObjectKey]">
            <template v-if="language === 'IT'">
              {{ tag.label }}
            </template>
            <template v-else>
              {{ tag.label_en }}
            </template>
          </option>
        </select>
      </template>

      <!-- Level 4 -->
      <template v-if="tagsSchema.level4.length > 0 && selectedTagsSchema[2]">             
        <select class="form-control mb-2" id="tag-level4" @change="updateTags($event)" v-model="selectedTagsSchema[3]">
          <option v-for="tag in tagsSchema.level4" :key="tag[tagsObjectKey]" :value="tag[tagsObjectKey]">
            <template v-if="language === 'IT'">
              {{ tag.label }}
            </template>
            <template v-else>
              {{ tag.label_en }}
            </template>
          </option>
        </select>
      </template>

      <!-- Level 5 -->
      <template v-if="tagsSchema.level5.length > 0 && selectedTagsSchema[3]">             
        <select class="form-control mb-2" id="tag-level5" @change="updateTags($event)" v-model="selectedTagsSchema[4]">
          <option v-for="tag in tagsSchema.level5" :key="tag[tagsObjectKey]" :value="tag[tagsObjectKey]">
            <template v-if="language === 'IT'">
              {{ tag.label }}
            </template>
            <template v-else>
              {{ tag.label_en }}
            </template>
          </option>
        </select>
      </template>

      <!-- Level 6 -->
      <template v-if="tagsSchema.level6.length > 0 && selectedTagsSchema[4]">             
        <select class="form-control mb-2" id="tag-level6" v-model="selectedTagsSchema[5]">
          <option v-for="tag in tagsSchema.level6" :key="tag[tagsObjectKey]" :value="tag[tagsObjectKey]">
            <template v-if="language === 'IT'">
              {{ tag.label }}
            </template>
            <template v-else>
              {{ tag.label_en }}
            </template>
          </option>
        </select>
      </template>

      <h4 class="paragraph-object-add-tags__inner-title mt-5">
        <svg viewBox="-1 0 136 136.21852"><path d="M 93.148438 80.832031 C 109.5 57.742188 104.03125 25.769531 80.941406 9.421875 C 57.851562 -6.925781 25.878906 -1.460938 9.53125 21.632812 C -6.816406 44.722656 -1.351562 76.691406 21.742188 93.039062 C 38.222656 104.707031 60.011719 105.605469 77.394531 95.339844 L 115.164062 132.882812 C 119.242188 137.175781 126.027344 137.347656 130.320312 133.269531 C 134.613281 129.195312 134.785156 122.410156 130.710938 118.117188 C 130.582031 117.980469 130.457031 117.855469 130.320312 117.726562 Z M 51.308594 84.332031 C 33.0625 84.335938 18.269531 69.554688 18.257812 51.308594 C 18.253906 33.0625 33.035156 18.269531 51.285156 18.261719 C 69.507812 18.253906 84.292969 33.011719 84.328125 51.234375 C 84.359375 69.484375 69.585938 84.300781 51.332031 84.332031 C 51.324219 84.332031 51.320312 84.332031 51.308594 84.332031 Z M 51.308594 84.332031" /></svg>
        Search {{ modalTitle }}
      </h4>

      <template v-if="language === 'IT'">
        <v-select label="label" :options="tags" v-model="selectedSearch">
          <template v-slot:option="tag">
            {{ tag.label }}
            <cite>
              <span v-if="tag.lev_1">{{ tagsLabels[tag.lev_1] }}</span>
              <span v-if="tag.lev_2"> &mdash; {{ tagsLabels[tag.lev_2] }}</span>
              <span v-if="tag.lev_3"> &mdash; {{ tagsLabels[tag.lev_3] }}</span>
              <span v-if="tag.lev_4"> &mdash; {{ tagsLabels[tag.lev_4] }}</span>
              <span v-if="tag.lev_5"> &mdash; {{ tagsLabels[tag.lev_5] }}</span>
              <span v-if="tag.lev_6"> &mdash; {{ tagsLabels[tag.lev_6] }}</span>
            </cite>
          </template>
        </v-select>
      </template>
      <template v-else>
        <v-select label="label_en" :options="tags" v-model="selectedSearch">
          <template v-slot:option="tag">
            {{ tag.label_en }}
            <cite>
              <span v-if="tag.lev_1">{{ tagsLabels[tag.lev_1] }}</span>
              <span v-if="tag.lev_2"> &mdash; {{ tagsLabels[tag.lev_2] }}</span>
              <span v-if="tag.lev_3"> &mdash; {{ tagsLabels[tag.lev_3] }}</span>
              <span v-if="tag.lev_4"> &mdash; {{ tagsLabels[tag.lev_4] }}</span>
              <span v-if="tag.lev_5"> &mdash; {{ tagsLabels[tag.lev_5] }}</span>
              <span v-if="tag.lev_6"> &mdash; {{ tagsLabels[tag.lev_6] }}</span>
            </cite>
          </template>
        </v-select>
      </template>

      <template v-if="monitorRecentTargets.length > 0 && tagType == 'targets'">
        <h4 class="paragraph-object-add-tags__inner-title mt-5">
          Recent Tags
        </h4>
        <ul class="paragraph-object-add-tags__recent-tags">
          <li v-for="target in monitorRecentTargets" :key="target.gandtarget_id" @click="addRecentTag(target)">
            <p>{{ target.label_en }}</p>
          </li>
        </ul>
      </template>

      <template v-if="monitorRecentTaxonomies.length > 0 && tagType == 'taxonomies'">
        <h4 class="paragraph-object-add-tags__inner-title mt-5">
          Recent Tags
        </h4>
        <ul class="paragraph-object-add-tags__recent-tags">
          <li v-for="taxonomy in monitorRecentTaxonomies" :key="taxonomy.tax_id" @click="addRecentTag(taxonomy)">
            <p>{{ taxonomy.label_en }}</p>
          </li>
        </ul>
      </template>

      <b-button variant="primary" @click="addTag" class="mt-5">Add tag</b-button>
    </div>

  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';

export default {
  name: 'MonitorTags',
  props: ['modalTagId', 'tagType', 'currentTargets', 'currentTaxonomies'],
  components: {
    vSelect,
  },
  data() {
    return {
      modalTitle: '',
      tagsObjectKey: '',
      tagsCurrentObjectKey: '',
      tagsLabelKey: '',
      tags: [],  
      tagsSchema: {
        level1: [],
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: []
      },
      tagsLabels: [],
      selectedTagsSchema: [],
      selectedSearch: null,
      language: 'EN',
      alert: {
        show: 0,
        type: '',
        content: ''
      }
    }
  },
  computed: {
    ...mapGetters(["taxonomies", "targets", "monitorCurrent", "monitorRecentTargets", "monitorRecentTaxonomies"])
  },
  methods: {
    alertCountDownChanged(dismissCountDown) {
      this.alert.show = dismissCountDown
    },
    setTagType() {
      if (this.tagType === 'taxonomies') {
        this.modalTitle = 'Taxonomies';
        this.tagsObjectKey = 'tax_id';
        this.tagsCurrentObjectKey = 'currentTaxonomies';
        this.tags = this.taxonomies;  
      } else {
        this.modalTitle = '3G & Targets';
        this.tagsObjectKey = 'gandtarget_id';
        this.tagsCurrentObjectKey = 'currentTargets';
        this.tags = this.targets;      
      }
    },
    setTagsSchemaLev1() {
      for (let i = 0; i < this.tags.length; i++) {
        if(this.tags[i][this.tagsObjectKey] === this.tags[i].lev_1 ) {
          this.tagsSchema.level1.push(this.tags[i]);
        }
      }
    },
    updateTags: function(event) {
      let arrayResult = [];
      let i;

      // Update Level 1
      if (event.target.id === 'tag-level1') {
        for (i = 0; i < this.tags.length; i++) {
          if (
            this.tags[i].lev_1 === event.target.value 
            && this.tags[i].lev_3 === ''
            && !(this.tags[i][this.tagsObjectKey] == event.target.value)
          ) {
            arrayResult.push(this.tags[i]);
          }             
        }
        this.selectedTagsSchema.length = 1;
        this.tagsSchema.level2 = arrayResult;
        this.tagsSchema.level3 = [];
        this.tagsSchema.level4 = [];
        this.tagsSchema.level5 = [];
        this.tagsSchema.level6 = [];
        this.selectedSearch = null;
      }

      // Update Level 2
      if (event.target.id === 'tag-level2') {
        for (i = 0; i < this.tags.length; i++) {
          if (
            this.tags[i].lev_2 === event.target.value 
            && this.tags[i].lev_4 === ''
            && !(this.tags[i][this.tagsObjectKey] == event.target.value)
          ) {
            arrayResult.push(this.tags[i]);
          }             
        }
        this.selectedTagsSchema.length = 2;
        this.tagsSchema.level3 = arrayResult;
        this.tagsSchema.level4 = [];
        this.tagsSchema.level5 = [];
        this.tagsSchema.level6 = [];
      }

      // Update Level 3
      if (event.target.id === 'tag-level3') {
        for (i = 0; i < this.tags.length; i++) {
          if (
            this.tags[i].lev_3 === event.target.value 
            && this.tags[i].lev_5 === ''
            && !(this.tags[i][this.tagsObjectKey] == event.target.value)
          ) {
            arrayResult.push(this.tags[i]);
          }             
        }
        this.selectedTagsSchema.length = 3;
        this.tagsSchema.level4 = arrayResult;
        this.tagsSchema.level5 = [];
        this.tagsSchema.level6 = [];
      }

      // Update Level 4
      if (event.target.id === 'tag-level4') {
        for (i = 0; i < this.tags.length; i++) {
          if (
            this.tags[i].lev_4 === event.target.value 
            && this.tags[i].lev_6 === ''
            && !(this.tags[i].tax_id == event.target.value)
            && !(this.tags[i][this.tagsObjectKey] == event.target.value)
          ) {
            arrayResult.push(this.tags[i]);
          }             
        }
        this.selectedTagsSchema.length = 4;
        this.tagsSchema.level5 = arrayResult;
        this.tagsSchema.level6 = [];
      }

      // Update Level 5
      if (event.target.id === 'tag-level5') {
        for (i = 0; i < this.tags.length; i++) {
          if (
            this.tags[i].lev_5 === event.target.value
            && !(this.tags[i][this.tagsObjectKey] == event.target.value)
          ) {
            arrayResult.push(this.tags[i]);
          }             
        }
        this.selectedTagsSchema.length = 5;
        this.tagsSchema.level6 = arrayResult;
      }
    },
    addRecentTag(tag) {
      this.selectedSearch = tag;
      this.addTag();
    },
    addTag() {
      if(this.selectedSearch) {

        // Controllo se è già presente nei tag selezionati
        let alreadyAdded = false;
        let alertContent = '';

        for (let ts = 0; ts < this[this.tagsCurrentObjectKey].length; ts++) {
          if(this[this.tagsCurrentObjectKey][ts][this.tagsObjectKey] === this.selectedSearch[this.tagsObjectKey]) {
            alreadyAdded = true;
            alertContent = this.selectedSearch.label_en + ' already added';
          }
        }

        if(!alreadyAdded) {
          this.$emit('requestAddTag', this.selectedSearch);
          this.alert.show = 3;
          this.alert.type = 'success';
          this.alert.content = this.selectedSearch.label_en + ' has been added';
          this.selectedSearch = null;        
        } else {
          this.alert.show = 3;
          this.alert.type = 'danger';
          this.alert.content = alertContent;
        }

        this.selectedSearch = null;  

      } else {
        let selectedTagId = null;

        for (let i = 0; i < this.selectedTagsSchema.length; i++) {
          if (this.selectedTagsSchema[i] != '' && this.selectedTagsSchema[i] != undefined) {
            selectedTagId = this.selectedTagsSchema[i];
          }
        }
        for (let j = 0; j < this.tags.length; j++) {
          if (this.tags[j][this.tagsObjectKey] === selectedTagId) {

            if(this.tags[j]['lev_2'] == '' && this.tags[j]['lev_1'] != 't0000') {
              this.alert.show = 3;
              this.alert.type = 'danger';
              this.alert.content = this.tags[j].label_en + ' cannot be added';
              break;
            }

            // Controllo se è già presente nei tag selezionati
            let alreadyAdded = false;

            for (let t = 0; t < this[this.tagsCurrentObjectKey].length; t++) {
              if(this[this.tagsCurrentObjectKey][t][this.tagsObjectKey] === this.tags[j][this.tagsObjectKey]) {
                alreadyAdded = true;
              }
            }

            if(!alreadyAdded) {
              this.$emit('requestAddTag', this.tags[j]);
              this.selectedTagsSchema = [];
              this.alert.show = 3;
              this.alert.type = 'success';
              this.alert.content = this.tags[j].label_en + ' has been added';
            } else {
              this.alert.show = 3;
              this.alert.type = 'danger';
              this.alert.content = this.tags[j].label_en + ' already added';
            }
            break
          }
        }
      }     
    },
    resetTagSchema() {
      this.tagsSchema = {
        level1: [],
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: []
      };
    },
    setTagLabels() {
      let labelsArray = [];
      for(let i = 0; i < this.tags.length; i++) {
        labelsArray[this.tags[i][this.tagsObjectKey]] = this.tags[i].label;
      }
      this.tagsLabels = labelsArray;
    },
    resetAlert() {
      this.alert.show = 0;
      this.alert.type = '';
      this.alert.content = '';
    }
  },
  mounted() {
    this.setTagType();
    this.setTagsSchemaLev1();
    this.setTagLabels();
    this.resetAlert();
  },
  watch: {
    tagType: function() {
      this.resetTagSchema();
      this.setTagType();
      this.setTagsSchemaLev1();
      this.setTagLabels();
      this.resetAlert();
    }
  }
}
</script>

<style lang="scss">
.paragraph-object-add-tags-alert {

  .alert {
    font-size: rem(14px);

    &-danger {
      background-color: $color-sunset;
      border-color: $color-sunset;
      color: #fff;
    }

    &-success {
      background-color: $color-java;
      border-color: $color-java;
      color: #fff;
    }
  }
}

.paragraph-object-add-tags {

  .form-control {
    margin-bottom: rem(16px);
    font-size: rem(14px);
  }

  &__inner-title {
    font-size: rem(16px);
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: rem(8px);

    svg {
      display: inline;
      width: rem(14px);
      height: rem(14px);
      fill: $color-genoa;
    }
  }
}

.paragraph-object-add-tags__recent-tags {
  margin: 0;
  padding: 0;
  list-style: none;
  margin-bottom: rem(16px);

  li {
    margin-right: rem(8px);
    margin-bottom: rem(8px);
    padding: rem(4px) rem(8px);    
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: inline-block;

    &:last-child {
      margin-right: 0;
    }

    p {
      margin-bottom: 0;
      font-size: rem(13px);
      color: $color-java;
      text-transform: uppercase;
      display: inline-block;
      margin-right: rem(8px);
      transition: color .3s ease;
    }

    &:hover {
      cursor: pointer;

      p {
        color: $color-genoa;
      } 
    }
  }
}
</style>